var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0296 18.495L25.1996 16.665C24.7646 16.29 24.5096 15.735 24.4946 15.12C24.4646 14.445 24.7346 13.77 25.2296 13.275L27.0296 11.475C28.5896 9.915 29.1746 8.415 28.6796 7.23C28.1996 6.06 26.7146 5.415 24.5246 5.415H8.84961V4.125C8.84961 3.51 8.33961 3 7.72461 3C7.10961 3 6.59961 3.51 6.59961 4.125V31.875C6.59961 32.49 7.10961 33 7.72461 33C8.33961 33 8.84961 32.49 8.84961 31.875V24.555H24.5246C26.6846 24.555 28.1396 23.895 28.6346 22.71C29.1296 21.525 28.5596 20.04 27.0296 18.495Z",
    fill: "#FCC958"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.8ce3123dab7a2f68a357d96a7065316e.svg";
export { ForwardRef as ReactComponent };